import React, { useCallback, useEffect, useState } from "react";
import { getPreGeneratedReports } from "../../services/integrationService";
import { getAccessToken } from "../../services/authenticationService"; 
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper, Button } from "@mui/material";
import "./preGeneratedReports.css";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
interface PreGeneratedReport {
  fileName: string;
  timestamp: string;
  status: "SUCCESS" | "FAILURE";
  downloadUrl?: string;
}

export function PreGeneratedReports() {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "Pre Generated Reports"
  const CUR_COMPONENT_COMMON = "commonPortal";
  const [preGeneratedReports, setPreGeneratedReports] = useState<PreGeneratedReport[]>([]);
  const headers = ['NAME', 'LAST MODIFIED', 'ACTION'];
  const fetchPreGeneratedReports = useCallback(async () => {
    try {
      const response = await getPreGeneratedReports();
      const features = response?.data?.features ?? [];

      const mappedData: PreGeneratedReport[] = features.map((item: any) => ({
        fileName: item.attributes?.name ?? "-",
        timestamp: item.lastModifiedTime,
        status: item.status,
        downloadUrl:
          item.status === "SUCCESS" ? item.attributes?.fileKeys?.[0] : undefined,
      }));
      setPreGeneratedReports(mappedData);
    } catch (error) {
      console.error("Failed to fetch pre-generated reports", error);
    }
  }, []);
  const handleBackClick = () => {
    window.history.back();
  };
  useEffect(() => {
    fetchPreGeneratedReports();
  }, [fetchPreGeneratedReports]);
  const formatDate = (timestamp: string) => {
    const date = new Date(timestamp);
    const formattedDate = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    return formattedDate;
  };

  const handleDownload = (fileUrl?: string) => {
      if (!fileUrl) return;

      const token = getAccessToken();
      if (!token) {
        console.error("Access token not found");
        return;
      }

      const downloadUrl = `${fileUrl}?access_token=${token}`;
      window.open(downloadUrl, "_blank");
    };



  return (
    <>
      <TableContainer component={Paper} sx={{ paddingTop: '5rem', position: "relative", fontWeight: "bold", borderRadius: "10px", boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)", paddingRight: "5rem" }}>
        <Typography variant="h6" fontWeight="medium" sx={{ position: "absolute", left: "20px", top: "30px", paddingBottom: "3rem" }}>{translate(TranslationEnum.master_data_reports, "Pre-Generated Reports")}</Typography>
        <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleBackClick}
            style={{ color: "white", backgroundColor: "#24c6b1", fontWeight: "bold" }}
          >
            {translate(TranslationEnum.common_portal, "BACK")}
          </Button>
        </div>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableCell key={header} sx={{ color: '#8392AB', fontWeight: 'bold', paddingBottom: '0.5rem', fontSize: "0.65rem" }} align="center">
                  {translate(TranslationEnum.master_data_reports, header)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {preGeneratedReports.map((row, index) => (
              <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#f5f5f5' }, height: '3rem' }}>
                <TableCell style={{ fontSize: '0.8rem', paddingRight: '0.75rem', color: '#67748e', fontWeight: 580 }} align="center">{row.fileName}</TableCell>
                <TableCell style={{ fontSize: '0.8rem', paddingRight: '0.75rem', color: '#67748e', fontWeight: 580 }} align="center">{formatDate(row.timestamp)}</TableCell>
                <TableCell
                  style={{ fontSize: '0.9rem', paddingRight: '0.75rem', color: '#67748e' }}
                  align="center"
                >
                  {row.status === "SUCCESS" && row.downloadUrl ? (
                    <span
                      className="hoverLink"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDownload(row.downloadUrl)}
                    >
                      Download
                    </span>
                  ) : (
                    <span style={{ color: "#9e9e9e", cursor: "not-allowed" }}>
                      Download
                    </span>
                  )}
                </TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
